import { Http } from '../../shared';
import { settings } from '../../settings';

export class TripService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.gateway_api.base_url;
    }
    serialize(obj, prefix) {
        var str = [];
        var p;
        for (p in obj) {
            if (Object.hasOwn(obj, p)) {
                var k = prefix ? prefix
                    + (Array.isArray(obj) ? "[" + p + "]" : '.' + p)
                    : p;
                var v = obj[p];
                str.push((v !== null && typeof v === "object") ?
                    this.serialize(v, k) :
                    encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
        return str.join("&");
    }
    async search(query) {
        var queryString = this.serialize(query)
        var response = await this.http.get(this.service_url + '/trips?' + queryString);
        var result = {
            data: response.data,
            page_size: response.headers['x-pagination-page-size'],
            page_number: response.headers['x-pagination-page-number'],
            total_size: response.headers['x-pagination-total-size'],
        };
        return result;
    }
}
